import React, { FunctionComponent, useRef } from 'react'
import { Field } from '../../../types/Form/IForm'
import { DatePicker, DateTimePicker } from "@progress/kendo-react-dateinputs";
import { FieldRenderProps } from '@progress/kendo-react-form';

export const DateField: FunctionComponent<FieldRenderProps> = props => {
  const { field, value, ...others } = props;
  const defVal = field?.VALUES?.length > 0 ? new Date(field?.VALUES[0]) : undefined //props.ConfigSettings?.Default === "2" ? new Date(Date.parse(props.ConfigSettings?.DefaultValue)) : (props.ConfigSettings?.Default === "1" ? new Date() : null);
  const wrapper = useRef();
  const onChange = (e) => {
    let fieldChange = { ...field, VALUES: e.target.value ? [new Date(e.target.value).toISOString().replace('Z', '')] : null }
    props.onChange({ value: fieldChange });
  }
  // defaultValue={defVal}
  if (field.ConfigSettings?.Display === "1")
    return <>
      <DateTimePicker {...others} onChange={onChange} value={defVal} /></>
  else
    return (
      <div ref={wrapper}>
        <DatePicker {...others} popupSettings={{ popupClass: 'z500' }} onChange={onChange} value={defVal} />
      </div>

    )

}
